import { createSelector } from 'reselect';
import filterObject from 'services/filterObject';

// get data from store
const getLocations = state => state.locations;
const getSearchTerm = state => state.searchTerm;
const getHeadquartersVisibility = state => state.mapSettings.headquarters;

// filter locations based on the 'headquarters' param set in store
export const getLocationsWithHeadquarters = createSelector(
    [getLocations, getHeadquartersVisibility],
    (locations, headquarters) => (
        filterObject(locations, (location) => {
            const { headquarter } = location;

            return !headquarter || headquarters;
        })
    )
);

// filter locations based on the previous selector and 'searchTerm' set in store
export const getFilteredLocations = createSelector(
    [getLocationsWithHeadquarters, getSearchTerm],
    (locations, searchTerm) => (
        filterObject(locations, (location) => {
            const { title, fullAddress } = location;
            const address = fullAddress ? fullAddress.address : '';
            const searchString = `${title} ${address}`.toLowerCase();

            return searchString.indexOf(searchTerm.toLowerCase()) > -1;
        })
    )
);
